module.exports = __webpack_public_path__ + "static/media/textbook_korean8.244bb306.png";